var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54833 10.0001L10.9167 3.63176C11.6067 2.94176 11.6067 1.82176 10.9167 1.13176C10.2267 0.441758 9.10667 0.441758 8.41667 1.13176L0.726665 8.82176C0.0749983 9.47342 0.0749983 10.5284 0.726665 11.1784L8.41667 18.8684C9.10667 19.5584 10.2267 19.5584 10.9167 18.8684C11.6067 18.1784 11.6067 17.0584 10.9167 16.3684L4.54833 10.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.b0bfe204d072692d2d02980baab6ef65.svg";
export { ForwardRef as ReactComponent };